const ABORT_ERROR_NAME = 'AbortError';
const ABORT_ERROR_MESSAGE_MARKERS = [
  'the user aborted a request',
  'signal is aborted without reason',
];

// jsdom's DOMException does not satisfy `instanceof Object`, so gate on
// typeof/null instead of instanceof when narrowing an unknown error.
const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

// Apollo can surface an aborted fetch as a bare DOMException, or wrap it in a
// networkError/cause chain — check every shape before falling back to loglevel.
export function isAbortError(error: unknown): boolean {
  if (!isRecord(error)) {
    return false;
  }

  if (error['name'] === ABORT_ERROR_NAME) {
    return true;
  }

  const networkError = error['networkError'];
  if (isRecord(networkError) && networkError['name'] === ABORT_ERROR_NAME) {
    return true;
  }

  const cause = error['cause'];
  if (isRecord(cause) && cause['name'] === ABORT_ERROR_NAME) {
    return true;
  }

  if (typeof error['message'] === 'string') {
    const lowerMessage = error['message'].toLowerCase();
    if (
      ABORT_ERROR_MESSAGE_MARKERS.some((marker) =>
        lowerMessage.includes(marker),
      )
    ) {
      return true;
    }
  }

  return false;
}
